import { Tabs } from 'antd';
import { RegistryTab } from './RegistryTab';
import { VersionsTab } from './VersionsTab';

export function Documents() {
  return (
    <Tabs
      items={[
        { key: 'registry', label: 'Реестр документов', children: <RegistryTab /> },
        {
          key: 'versions',
          label: 'Версии документов',
          children: <VersionsTab />,
        },
      ]}
    />
  );
}
